<template>
  <section
    class="catalog-product"
    v-bind="result.attributes"
    @mouseover="handlerMouseOver"
    @mouseleave="isMouseOver = false"
  >
    <div class="catalog-product__header">
      <div class="product-items">
        <div>
          <DefLabels :result="result.labels" />
        </div>
        <div>
          <DefFavourite :result="result" />
        </div>
      </div>
      <a :href="result.detailPage" class="catalog-product__picture" @click="eCommerceSend">
        <img
          :src="result.pictures[1] && result.pictures[1].src"
          alt="product"
          class="catalog-product__img-2"
          :class="{
            'catalog-product__img_active':
              isMouseOver && !isMouseOverButton && !result.pictures[1].isPicturePlug,
          }"
        />
        <DefImg
          :result="result.pictures[0]"
          alt="product"
          class="catalog-product__img-1"
          :class="{
            'catalog-product__img_active':
              !isMouseOver || isMouseOverButton || result.pictures[1].isPicturePlug,
          }"
          :transition="false"
        />
      </a>
      <transition name="fade">
        <span
          v-if="isMouseOver"
          class="catalog-product__view"
          @click.prevent="handlerOpenModal"
          @mouseover="isMouseOverButton = true"
          @mouseleave="isMouseOverButton = false"
        >
          {{ messages.glance }}
        </span>
      </transition>
      <GiaPhoto v-if="result.isGia" />
    </div>
    <a :href="result.detailPage" class="catalog-product__footer" @click="eCommerceSend">
      <DefColorsSmall :result="result" />
      <span class="catalog-product__name">
        {{ result.type }}
      </span>
      <span v-if="result.collection" class="catalog-product__collection">
        {{ result.collection?.name }}
      </span>
      <span v-if="result.price" class="catalog-product__prices">
        <DefPrice v-if="result.price.printPrice">
          {{ result.price.printPrice }}
        </DefPrice>
        <DefPriceOld v-if="result.price.printPriceOld">
          {{ result.price.printPriceOld }}
        </DefPriceOld>
      </span>
      <span>
        <DefPriceEN>
          {{ result?.price?.printPriceEUR }}
        </DefPriceEN>
      </span>
    </a>
  </section>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import DefLabels from '@components/Def/DefLabels/DefLabels.vue';
import DefFavourite from '@components/Def/DefFavourite/DefFavourite.vue';
import DefImg from '@components/Def/DefImg/DefImg.vue';
import GiaPhoto from '@components/Product/GiaPhoto.vue';
import DefColorsSmall from '@components/Def/DefColors/DefColorsSmall.vue';
import DefPrice from '@components/Def/DefPrice/DefPrice.vue';
import DefPriceOld from '@components/Def/DefPriceOld/DefPriceOld.vue';
import DefPriceEN from '@components/Def/DefPrice/DefPriceEN.vue';
import CatalogProductModal from '@components/Catalog/CatalogProductModal.vue';
import useModal from '@use/useModal/useModal';
import useScreenWidth from '@use/useScreenWidth';
import Analytics from '@/utils/Analytics';

export default {
  name: 'CatalogProduct',
  components: {
    DefPriceEN,
    DefPriceOld,
    DefPrice,
    DefColorsSmall,
    GiaPhoto,
    DefImg,
    DefFavourite,
    DefLabels,
  },
  props: ['result'],
  data() {
    return {
      isMouseOver: false,
      isMouseOverButton: false,
      modal: useModal(),
      screenWidth: useScreenWidth(),
    };
  },
  computed: {
    ...mapState({
      messages: ({ results }) => results?.messages,
      dataLayer: ({ catalog }) => catalog.data.catalogSectionList.dataLayer,
      pagination: ({ catalog }) => catalog.data.catalogSectionList.pagination,
    }),
  },
  methods: {
    ...mapActions({
      getProductPageData: 'product/getPageData',
    }),
    handlerMouseOver() {
      if (this.screenWidth >= 992) this.isMouseOver = true;
    },
    async handlerOpenModal() {
      try {
        const data = await this.getProductPageData({ url: this.result.detailPage });

        this.modal.show(CatalogProductModal, {}, { width: '1000px' });

        if (data?.product) {
          Analytics.viewDetailProduct(data.product);
        }
      } catch (err) {
        console.error(err);
      }
    },
    eCommerceSend() {
      Analytics.clickOnProduct(this.result, this.pagination.pageNumber);
    },
  },
};
</script>

<style lang="scss" scoped>
.catalog-product {
  &__header {
    position: relative;
    background-position: center;
    background-repeat: no-repeat;
    background-size: 100% auto;
    margin-bottom: 7px;
    cursor: pointer;
  }
  &__footer {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  &__name {
    text-align: center;
    margin-bottom: 8px;
    max-height: 18px;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 14px;
    font-weight: 500;
    line-height: 125%;
    text-transform: uppercase;
    @include point-md {
      font-size: rem(16);
      max-height: 20px;
    }
  }
  &__collection {
    text-align: center;
    text-transform: uppercase;
    color: var(--color-dark-grey);
    margin-bottom: 16px;
    font-size: 12px;
    font-weight: 500;
    line-height: 125%;
    text-transform: uppercase;
  }
  &__view {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    bottom: 10px;
    left: 12px;
    right: 12px;
    font-size: 14px;
    font-weight: 600;
    line-height: 20px;
    text-transform: uppercase;
    height: 36px;
    background-color: rgba(239, 230, 204, 0.8);
    cursor: pointer;
    transition: 0.2s linear background-color;
    z-index: 2;

    &:hover {
      background-color: rgba(3, 3, 4, 0.8);
      color: #fff;
    }
  }
  &__picture {
    position: relative;
    overflow: hidden;
  }
  &__img {
    animation: brightness 0.5s reverse;
    &-1 {
      opacity: 0;
      position: relative;
      padding: 24px 20px;
      @include point-md {
        padding: 24px 22px;
      }
      @include point-lg {
        padding: 24px;
      }
    }
    &-2 {
      opacity: 0;
      position: absolute;
      top: 0;
    }
    &_active {
      opacity: 1;
      z-index: 1;
      animation: brightness 0.5s linear;
    }
  }
  &__prices {
    display: flex;
    flex-direction: column-reverse;
    gap: 2px;
    @include point-md {
      flex-direction: row;
      align-items: center;
      gap: 8px;
    }
  }
  :deep(.def-img) {
    width: 100%;
  }
  :deep(.def-colors-small) {
    margin-bottom: 12px;
  }
  :deep(.gia-photo) {
    position: absolute;
    right: 12px;
    bottom: 12px;
    z-index: 1;
    @include point-lg {
      bottom: 52px;
    }
  }
}
.product-items {
  position: absolute;
  left: 12px;
  right: 12px;
  top: 8px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  z-index: 2;
}
@keyframes brightness {
  0% {
    opacity: 0;
  }
  100% {
    filter: none;
    opacity: 1;
  }
}
</style>
